import React from 'react';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 40, 
  color = '#4f46e5' 
}) => {
  return (
    <div className="loading-spinner-container">
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 38 38" 
        xmlns="http://www.w3.org/2000/svg"
        stroke={color}
        className="animate-spin"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)" strokeWidth="2">
            <circle strokeOpacity=".3" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
            </path>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default LoadingSpinner; 